import {cardConstants} from '../constants';

const cardState = {
  cardsSummaries: [],
};

const cardReducer = (state = cardState, action) => {
  const {type, data} = action;
  switch (type) {
    case cardConstants.CLEAR_CARDS_DATA:
      return {
        cardsSummaries: [],
      }
    case cardConstants.GET_CARDS_SUMMARIES:
      return {
        ...state,
        cardsSummaries: data
      }
    default:
      return state;
  }
};

export default cardReducer;
